import React, { Component } from "react";
import { EventBus, EventBusEvents } from "@/store/event-bus.ts";
import Textinput from "@/components/ui/Textinput.jsx";
import Button from "@/components/ui/Button.jsx";
import Textarea from "@/components/ui/Textarea.jsx";


import { constants } from "@/constants.js";
import { useQueryClient} from "react-query";
import { isValidUrl, urlChatID } from "@/utils/url.js";
import { toast } from "react-toastify";
import ListLinks from "@/pages/chatbot/sources/ListLinks.jsx";
import {useTranslation} from "react-i18next";

const ChatBotSourcesWebsite = () => {
  const {t} = useTranslation();
  const [url, setURL] = React.useState("");
  const [urlsText, setUrlsText] = React.useState("");
  const [urlsLine, setUrlsLine] = React.useState(0);

  const queryClient = useQueryClient();
  const parse = async function () {
    try {
      let body = {};
      if (urlsText) {
        body.urls = urlsText.split("\n");
      } else if (url) {
        body.url = url;
      } else {
        toast.error(
          "Insert one URL or sitemap URL or multiline text with URLs",
          {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
          },
        );
      }

      await fetch(`${constants.url.API_PREFIX}chatbot/${urlChatID()}/parse`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      EventBus.getInstance().dispatch("parser.start");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const validateUrlsText = (urlsText) => {
    let urls = urlsText.split("\n");
    for (let i = 0; i < urls.length; i++) {
      if (urls[i] !== "" && !isValidUrl(urls[i])) {
        return i + 1;
      }
    }
    return 0;
  };

  return (
    <div>
      <div className="bg-slate-50 p-4 rounded-lg">
        <div className="font-bold mb-2">{t("knowledge_base.web_pages.site_url")}</div>
        <Textinput
          error={url && !isValidUrl(url) ? { message: "Invalid URL" } : null}
          placeholder="https://mysite.com | https://mysite.com/sitemap.xml"
          onChange={(event) => {
            setURL(event.target.value);
          }}
          append={
            <Button text="Go" className="btn-outline-dark" onClick={parse} />
          }
        />

        <div className="py-2 text-sm opacity-70">
          {t("knowledge_base.web_pages.site_url_desc")}
        </div>
        <div className="font-bold mb-2 mt-6">{t("knowledge_base.web_pages.additional_links")}</div>
        <Textarea
          placeholder={t("knowledge_base.web_pages.additional_links_placeholder")}
          error={
            urlsLine
              ? {
                  message: `Invalid URL at line ${urlsLine} and will be ignored`,
                }
              : null
          }
          onChange={(event) => {
            let val = event.target.value;
            setUrlsText(val);
            let errLine = validateUrlsText(val);
            if (errLine !== urlsLine) {
              setUrlsLine(errLine);
            }
          }}
        />
        <div className="py-2 text-sm opacity-70">
          {t("knowledge_base.web_pages.additional_links_desc")}
        </div>
        <div className="flex justify-end py-2">
          <Button text={t("knowledge_base.web_pages.add_links")} className="btn-primary" onClick={parse} />
        </div>
      </div>

      <ListLinks />
    </div>
  );
};

export default ChatBotSourcesWebsite;
